import React from 'react';
import { ShieldCheck, CreditCard } from 'lucide-react';
import { trackAddToCartAndRedirect } from '../utils/metaPixel';
export function HeroSection() {
  return <section className="relative bg-brand-black bg-grid-pattern bg-grid-size pt-16 pb-20 px-4 overflow-hidden" data-id="element-60">
      {/* Subtle radial gradient overlay to focus center */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,#18181b_100%)] pointer-events-none" data-id="element-61"></div>

      <div className="relative max-w-5xl mx-auto flex flex-col items-center text-center z-10" data-id="element-62">
        <div className="inline-block mb-6 px-4 py-1.5 border border-brand-orange/30 bg-brand-orange/10 rounded-full" data-id="element-63">
          <p className="text-brand-orange font-montserrat font-bold text-sm md:text-base tracking-wider uppercase" data-id="element-64">
            For Families Living In U.S. Cities & Suburbs
          </p>
        </div>

        <h1 className="text-white text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 max-w-4xl" data-id="element-65">
          How To Protect Your Family In The Next 72 Hours Without Expensive
          Gear, A Bunker, Or Extreme Survival Tactics
        </h1>

        <p className="text-zinc-300 text-lg md:text-xl max-w-3xl mb-12 font-opensans leading-relaxed" data-id="element-66">
          A practical step-by-step system for U.S. families who want to stay
          safe during blackouts, supply shortages, and urban emergencies — even
          in a small apartment.
        </p>

        <div className="w-full max-w-3xl mx-auto mb-12 relative" data-id="element-67">
          <div className="absolute -inset-4 bg-brand-orange/20 blur-2xl rounded-full opacity-50" data-id="element-68"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qHAWdiPKRx8hVycPcKmAAe/mockup_producto_2.png" alt="The Urban Autonomy System on iPad and iPhone" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-69" />
        </div>

        <div className="w-full max-w-md mx-auto flex flex-col items-center" data-id="element-70">
          <a href="https://pay.hotmart.com/X104929887V?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={trackAddToCartAndRedirect} className="btn-crunchy w-full py-5 text-lg md:text-xl mb-4" data-id="element-71">
            Protect My Family Today
          </a>

          <div className="flex items-center justify-center gap-4 text-zinc-400 text-sm font-medium" data-id="element-72">
            <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-73" />
            <span data-id="element-74">Secure 256-bit Checkout</span>
          </div>
          <div className="flex items-center justify-center gap-3 mt-3 opacity-70" data-id="element-75">
            {/* Simple text representation of payment methods for trust */}
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-76">
              VISA
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-77">
              MASTERCARD
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-78">
              AMEX
            </span>
            <span className="px-2 py-1 border border-zinc-700 rounded text-xs text-zinc-300" data-id="element-79">
              PAYPAL
            </span>
          </div>
        </div>
      </div>
    </section>;
}